module.exports = __webpack_public_path__ + "media/images/floor_plan/table-33c323004fd7187989dff382c89b41a6.png";